import { defineComponent as _defineComponent } from 'vue'
import { useImage } from '@/shared/composables/image'
import { IEventEdit } from '@/enitites/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventDisplayMode',
  props: {
    eventData: null
  },
  setup(__props: any) {



const { getImageById } = useImage()

return { __sfc: true,getImageById }
}

})